module.exports = __webpack_public_path__ + "static/media/testfile_autotag.8e908d5a.zip";